<div>
    <label *ngIf="label" for="timeSelector" class="tw-text-main-text tw-text-xs">
        {{ label }}
    </label>
    <input
        #timeSelector
        type="time" 
        id="timeSelector" 
        class="tw-cursor-pointer tw-bg-white tw-border tw-border-border-light-gray tw-mb-3 tw-min-h-[50px] tw-p-2 tw-rounded-xl" 
        name="timeSelector"
        (change)="onTimeChange($event)"
        (click)="timeSelector.showPicker()"
    >
</div>
